<div class="tds-container-fluid">
    <div class="tds-row">
        <h2 class="tds-headline-02">Solicitação para Front Office</h2>
    </div>

    <tds-accordion>
        <!-- Filtros -->
        <tds-accordion-item header="Filtros" aria-level="6" expanded>
            <div class="tds-row">
                <tds-dropdown name="dropdown" label-position="outside" placeholder="Front-Office" size="lg" animation="slide" open-direction="auto" tds-aria-label="A dropdown component" style="padding-right: 45px; width: 10.8%">
                    <tds-dropdown-option value="option-1">Rafael Nunes</tds-dropdown-option>
                    <tds-dropdown-option value="option-2">Derick de Oliveira</tds-dropdown-option>
                </tds-dropdown>
                <tds-dropdown name="dropdown" label-position="outside" placeholder="Banco" size="lg" animation="slide" open-direction="auto" tds-aria-label="A dropdown component" style="padding-right: 45px; width: 10.8%">
                        <tds-dropdown-option value="option-1">Outros</tds-dropdown-option>
                        <tds-dropdown-option value="option-2">Scania Banco</tds-dropdown-option>
                </tds-dropdown>
                <tds-text-field type="date" helper="De *" size="lg" state="default" label="Label" label-position="no label" no-min-width placeholder="De *" tds-aria-label="A text field component" required="false" autocomplete="off" style="padding-right: 45px;"></tds-text-field>
                <tds-text-field type="date" helper="Até *" size="lg" state="default" label="Label" label-position="no label" no-min-width placeholder="Até *" tds-aria-label="A text field component" required="false" autocomplete="off" style="padding-right: 45px;"></tds-text-field>
                <div class="tds-row" style="padding-right: 20px;">
                    <a>Não definido</a>
                </div>
                <div class="tds-row">
                        <tds-radio-button name=”my-radio-button” value=”radio-value”> 
                        </tds-radio-button> Sim
                        <tds-radio-button name=”my-radio-button” value=”radio-value” style="padding-left: 10px;"> 
                        </tds-radio-button> Não
                </div>
            </div>

            <div class="tds-row" style="padding-top: 20px;">
                <tds-dropdown name="dropdown" label-position="outside" placeholder="Situações de Crédito" size="lg" animation="slide" open-direction="auto" tds-aria-label="A dropdown component" style="padding-right: 45px; width: 10.8%">
                    <tds-dropdown-option value="option-1">A vista</tds-dropdown-option>
                    <tds-dropdown-option value="option-2">Aprovado</tds-dropdown-option>
                </tds-dropdown>
                <tds-dropdown name="dropdown" label-position="outside" placeholder="Estagios Neg" size="lg" animation="slide" open-direction="auto" tds-aria-label="A dropdown component" style="padding-right: 45px; width: 10.8%">
                    <tds-dropdown-option value="option-1">Solic Faturamento</tds-dropdown-option>
                    <tds-dropdown-option value="option-2">Prog Solicitada</tds-dropdown-option>
                </tds-dropdown>
            </div>

            <div class="tds-row" style="padding-top: 20px; justify-content: center">
                <tds-button type="button" variant="primary" size="lg" text="Pesquisar" animation="none" tds-aria-label="undefined" name="" value="" style="padding-right: 5px;"></tds-button>
                <tds-button type="button" variant="secondary" size="lg" text="Limpar" animation="none" tds-aria-label="undefined" name="" value="" style="padding-right: 5px;"></tds-button>
            </div>
        </tds-accordion-item>

        <!-- Tabela -->
        <tds-accordion-item header="Tabela" aria-level="6" expanded>
            <div class="tds-row">
                <tds-table vertical-dividers="false" compact-design="false" responsive="true" no-min-width>
                    <tds-table-toolbar>
                        <div slot="end" class="tds-u-flex tds-u-align-items-center tds-u-h-100 tds-u-gap1" style="margin-left: 8px;">
                            <tds-button variant="secondary" size="sm" title="Exportar para Arquivo">
                                <tds-icon slot="icon" size="18px" name="document_xls"></tds-icon>
                            </tds-button>
                        </div>
                    </tds-table-toolbar>
                    <tds-table-header>
                        <tds-header-cell cell-key="actions"></tds-header-cell>
                        <tds-header-cell cell-key='solic' cell-value='Solicitação' sortable></tds-header-cell>
                        <tds-header-cell cell-key='razaoSocial' cell-value='Razão Social' sortable></tds-header-cell>
                        <tds-header-cell cell-key='cnpj' cell-value='CNPJ' sortable></tds-header-cell>
                        <tds-header-cell cell-key='modFinac' cell-value='Mod.Finac' sortable></tds-header-cell>
                        <tds-header-cell cell-key='negRef' cell-value='Neg.Ref' sortable></tds-header-cell>
                        <tds-header-cell cell-key='conc' cell-value='Conc.' sortable></tds-header-cell>
                        <tds-header-cell cell-key='fOffice' cell-value='F-Office' sortable></tds-header-cell>
                        <tds-header-cell cell-key='modelo' cell-value='Modelo' sortable></tds-header-cell>
                        <tds-header-cell cell-key='previsao' cell-value='Previsão' sortable></tds-header-cell>
                        <tds-header-cell cell-key='banco' cell-value='Banco' sortable></tds-header-cell>
                        <tds-header-cell cell-key='status' cell-value='Status' sortable></tds-header-cell>
                        <tds-header-cell cell-key='qtdBanco' cell-value='Qtd.Banco' sortable></tds-header-cell>
                        <tds-header-cell cell-key='qtdSolic' cell-value='Qtd.Solic' sortable></tds-header-cell>
                    </tds-table-header>
                    <tds-table-body>
                        <tds-table-body-row>
                            <tds-body-cell cell-key="actions">
                                <tds-checkbox value="checkbox-1" checkbox-id="first-checkbox" tds-aria-label="A checkbox component">
                                </tds-checkbox>
                            </tds-body-cell>
                            <tds-body-cell cell-key="solic">15221</tds-body-cell>
                            <tds-body-cell cell-key="razaoSocial">ED CARLOS COLETO DE MELO - ME</tds-body-cell>
                            <tds-body-cell cell-key="cnpj">33348764000121</tds-body-cell>
                            <tds-body-cell cell-key="modFinac">FINAME</tds-body-cell>
                            <tds-body-cell cell-key="negRef">16/5</tds-body-cell>
                            <tds-body-cell cell-key="conc">VARELLA-BRAS (235)</tds-body-cell>
                            <tds-body-cell cell-key="fOffice"></tds-body-cell>
                            <tds-body-cell cell-key="modelo">R 480 LA6X2 E5</tds-body-cell>
                            <tds-body-cell cell-key="previsao">26/04/2016</tds-body-cell>
                            <tds-body-cell cell-key="banco">Scania Banco</tds-body-cell>
                            <tds-body-cell cell-key="status">Vencida</tds-body-cell>
                            <tds-body-cell cell-key="qtdBanco">3</tds-body-cell>
                            <tds-body-cell cell-key="qtdSolic">1</tds-body-cell>
                        </tds-table-body-row>
                    </tds-table-body>
                </tds-table>
            </div>
        </tds-accordion-item>
    </tds-accordion>    
</div>